import React from 'react';

const BRAND_SPRITE = { url: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/9wavae5j_PUSHA%20TEE%20LOGO.png', w: 3645, h: 3088 };
const CLIENT_SPRITE = { url: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/kxc3bfgv_WEB%20HEADER%20-%20002-CLIENT%20LOGO.png', w: 4722, h: 3689 };

// Only the clients the owner approved naming. Logos come from the existing sprites; no logo → wordmark.
const CLIENTS = [
  { name: 'DJ Quik', s: BRAND_SPRITE, box: [2032, 1732, 2553, 2360] },
  { name: 'GZA', s: BRAND_SPRITE, box: [1114, 2423, 1625, 2880] },
  { name: 'Ice-T' },
  { name: 'Dead Prez', s: CLIENT_SPRITE, box: [2096, 176, 2496, 736] },
  { name: 'Visionaries', s: BRAND_SPRITE, box: [2008, 696, 2578, 1073] },
  { name: 'Beat Junkies', s: BRAND_SPRITE, box: [199, 2428, 802, 2839] },
  { name: 'EZ Mil' },
  { name: 'Coyote', s: BRAND_SPRITE, box: [2825, 735, 3451, 999] },
  { name: 'Funk Freaks', s: BRAND_SPRITE, box: [1910, 1322, 2675, 1505] },
  { name: 'LRG', s: BRAND_SPRITE, box: [215, 192, 784, 548] },
  { name: 'Garden Amp', s: BRAND_SPRITE, box: [290, 1782, 711, 2203] },
];

const H = 72;

function ClientMark({ name, s, box }) {
  if (!s) {
    return (
      <span role="img" aria-label={name} className="flex-shrink-0 font-display uppercase text-[#f4efe6]/70 hover:text-[#f4efe6] text-4xl md:text-5xl tracking-tight transition-colors duration-200">
        {name}
      </span>
    );
  }
  const [x0, y0, x1, y1] = box;
  const scale = H / (y1 - y0);
  return (
    <div
      role="img"
      aria-label={name}
      title={name}
      className="flex-shrink-0 opacity-70 hover:opacity-100 transition-opacity duration-200"
      style={{
        backgroundImage: `url(${s.url})`,
        backgroundSize: `${s.w * scale}px ${s.h * scale}px`,
        backgroundPosition: `-${x0 * scale}px -${y0 * scale}px`,
        backgroundRepeat: 'no-repeat',
        width: `${(x1 - x0) * scale}px`,
        height: `${H}px`,
        filter: 'invert(1) brightness(0.96) sepia(0.08) hue-rotate(-10deg) saturate(0.9)',
      }}
    />
  );
}

export default function TrustedBy() {
  const loop = [...CLIENTS, ...CLIENTS];
  return (
    <section className="relative bg-black border-y border-white/10 py-12 overflow-hidden" data-testid="trusted-by">
      <p className="text-center text-xs uppercase tracking-[0.3em] text-[#00b8ff] mb-8">Trusted by</p>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />
        <div className="flex items-center gap-16 md:gap-20 w-max animate-marquee">
          {loop.map((c, i) => <ClientMark key={`${c.name}-${i}`} {...c} />)}
        </div>
      </div>
      <ul className="sr-only">{CLIENTS.map((c) => <li key={c.name}>{c.name}</li>)}</ul>
    </section>
  );
}
